'use client'
import React from 'react'
import { usePathname } from 'next/navigation'
import { WordRotate } from './WordRotate'
import { motion } from "motion/react";
import { ColourfulText } from './colourful-text';
import LangToggle from './LangToggle';
import { pick, type Locale } from '@/lib/i18n'
import { commonDict } from '@/lib/i18n/dicts/common'
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Transition

} from '@headlessui/react'
import {
    ArrowPathIcon,
    Bars3Icon,
    ChartPieIcon,
    CursorArrowRaysIcon,
    FingerPrintIcon,
    SquaresPlusIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline'
import { ChevronDownIcon, PhoneIcon, PlayCircleIcon } from '@heroicons/react/20/solid'


const products = [
    { name: 'XXXXXXXXX', description: 'asasasw  qwd qwd qw ', href: '#', icon: ChartPieIcon },
    { name: 'XXXXX', description: 'qweqwedsadasdasdasda', href: '#', icon: CursorArrowRaysIcon },
    { name: 'XXXXXXXX', description: 'asdqwd asd asd ', href: '#', icon: FingerPrintIcon },
    { name: 'XXXXXX', description: 'asd asdsa dasd asd asd asd ', href: '#', icon: SquaresPlusIcon },
    { name: 'XXXXXXXXXX', description: 'asd asd asd wq dasd asd as ', href: '#', icon: ArrowPathIcon },
]
const callsToAction = [
    { name: 'Watch demo', href: '#', icon: PlayCircleIcon },
    { name: '联系我们', href: '../../contact', icon: PhoneIcon },
]



export default function HeaderMenu({ locale = 'zh' }: { locale?: Locale }) {
    const [appOpen, setAppOpen] = React.useState(false)
    const [libOpen, setLibOpen] = React.useState(false)
    const [scrolled, setScrolled] = React.useState(false)
    const pathname = usePathname()
    const t = pick(commonDict, locale)

    // 滚动时加深顶栏质感（毛玻璃+阴影）
    React.useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8)
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    // 导航项样式：当前页高亮 + hover 下划线动画
    const navCls = (href: string) => {
        const active = pathname === href || (href !== '/' && pathname.startsWith(href))
        return `relative text-sm/6 font-medium transition-colors duration-200 ${
            active ? 'text-indigo-600' : 'text-gray-900 hover:text-indigo-600'
        } after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:rounded-full after:bg-indigo-600 after:transition-all after:duration-300 ${
            active ? 'after:w-full' : 'after:w-0 hover:after:w-full'
        }`
    }

    return (
        <header className={`sticky top-0 inset-x-0 z-50 min-w-[1280px] border-b transition-all duration-300 ${
            scrolled
                ? 'bg-white/95 backdrop-blur-xl border-slate-900/10 shadow-[0_4px_24px_-8px_rgba(15,23,42,0.15)]'
                : 'bg-white border-slate-900/10'
        }`}>
            <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-5 lg:px-8">
                <div className="flex lg:flex-1">
                    <a href="../../" className="-m-1.5 p-1.5">
                        <span className="sr-only">YYGame</span>
                        <img
                            alt=""
                            src="../../img/logoapp.png"
                            className=" h-8 w-auto"
                        />
                    </a>
                    <div className="uppercase text-blue-700 flex flex-col items-left pl-2 -m-1.5 ml-1 ">
                        <a href="../../"><div className="text-xl ">YYGAME<strong className="font-bold">.TECH</strong></div></a>
                        <small className="tracking-widest text-xs">The best <ColourfulText text="mini games" /> you will find</small>
                        {/* <WordRotate className="text-xs tracking-widest"
                            words={["Your tagline goes here1", "Your tagline goes here2"]}
                        /> */}
                    </div>
                </div>

                {/* <div className="flex lg:hidden">
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(true)}
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon aria-hidden="true" className="size-6" />
                    </button>
                </div> */}
                <PopoverGroup className="hidden lg:flex lg:gap-x-12">
                    {/* <Popover className="relative">
                        <PopoverButton className="flex items-center gap-x-1 text-sm/6  font-medium text-gray-900">
                            游戏化互动
                            <ChevronDownIcon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                        </PopoverButton>

                        <PopoverPanel
                            transition
                            className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="p-4">
                                {products.map((item) => (
                                    <div
                                        key={item.name}
                                        className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-gray-50"
                                    >
                                        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                                            <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                                        </div>
                                        <div className="flex-auto">
                                            <a href={item.href} className="block font-semibold text-gray-900">
                                                {item.name}
                                                <span className="absolute inset-0" />
                                            </a>
                                            <p className="mt-1 text-gray-600">{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                                {callsToAction.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className="flex items-center justify-center gap-x-2.5 p-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-100"
                                    >
                                        <item.icon aria-hidden="true" className="size-5 flex-none text-gray-400" />
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                        </PopoverPanel>
                    </Popover> */}
                    {/* 内容为王：重点标记 + 下拉引导（推荐游戏 / 运营方案） */}
                    <div
                        className="relative"
                        onMouseEnter={() => setLibOpen(true)}
                        onMouseLeave={() => setLibOpen(false)}
                    >
                        <button
                            type="button"
                            onClick={() => setLibOpen(!libOpen)}
                            className={`relative flex items-center gap-x-1 text-sm/6 font-bold transition-colors duration-200 ${
                                pathname.startsWith('/gamelist2') || pathname.startsWith('/solutions')
                                    ? 'text-indigo-600'
                                    : 'text-gray-900 hover:text-indigo-600'
                            } after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:rounded-full after:bg-gradient-to-r after:from-indigo-600 after:to-fuchsia-600 after:transition-all after:duration-300 ${
                                pathname.startsWith('/gamelist2') || pathname.startsWith('/solutions') || libOpen ? 'after:w-full' : 'after:w-0 hover:after:w-full'
                            }`}
                        >
                            <span className="bg-gradient-to-r from-indigo-600 to-fuchsia-600 bg-clip-text text-transparent">
                                {t.nav.library}
                            </span>
                            <ChevronDownIcon className={libOpen ? 'rotate-180 transform size-5 flex-none text-gray-400 transition-transform duration-200' : 'size-5 flex-none text-gray-400 transition-transform duration-200'} />
                        </button>

                        {/* pt-3 作为 hover 桥接区 */}
                        <div className={`absolute -left-8 top-full z-10 w-screen max-w-sm pt-3 transition-all duration-200 ease-out ${libOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1 pointer-events-none'}`}>
                            <div className="overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-900/5">
                                <div className="p-2">
                                    {[
                                        { href: '../../gamelist2?tab=recommended', name: t.libraryMenu.featured, desc: t.libraryMenu.featuredDesc, icon: <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" /> },
                                        { href: '../../solutions', name: t.libraryMenu.solutions, desc: t.libraryMenu.solutionsDesc, icon: <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" /> },
                                    ].map((item) => (
                                        <a key={item.name} href={item.href}
                                            className="group flex items-center gap-x-4 rounded-xl px-3 py-3 hover:bg-indigo-50/60 transition-colors duration-150">
                                            <span className="flex size-10 flex-none items-center justify-center rounded-lg bg-indigo-50 ring-1 ring-indigo-100 group-hover:bg-white group-hover:ring-indigo-300 transition-colors duration-150">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 text-indigo-600">
                                                    {item.icon}
                                                </svg>
                                            </span>
                                            <span>
                                                <span className="block text-sm font-semibold text-gray-900 group-hover:text-indigo-700">{item.name}</span>
                                                <span className="mt-0.5 block text-xs text-gray-500">{item.desc}</span>
                                            </span>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="../../cooperate2" className={navCls('/cooperate2')}>
                        {t.nav.cooperate}
                    </a>

                    <a href="../../cases" className={navCls('/cases')}>
                        {t.nav.cases}
                    </a>

                    {/* 开发者：替代原「快速接入」飞书外链，飞书完整文档在 /developers 页内保留 */}
                    <a href="../../developers" className={navCls('/developers')}>
                        {t.nav.developers}
                    </a>
                    
                    
                    {/* 体验APP：鼠标滑入显示下拉二维码 */}
                    <div
                        className="relative"
                        onMouseEnter={() => setAppOpen(true)}
                        onMouseLeave={() => setAppOpen(false)}
                    >
                        <button
                            type="button"
                            className="flex items-center gap-x-1 text-sm/6 font-medium text-gray-900 hover:text-indigo-600 transition-colors duration-200"
                            onClick={() => setAppOpen(!appOpen)}
                        >
                            {t.nav.app}
                            <ChevronDownIcon className={appOpen ? 'rotate-180 transform size-5 flex-none text-gray-400 transition-transform duration-200' : 'size-5 flex-none text-gray-400 transition-transform duration-200'} />
                        </button>

                        {/* pt-3 作为 hover 桥接区，避免鼠标从按钮移到面板时掉落 */}
                        <div className={`absolute -left-24 top-full z-10 w-screen max-w-sm pt-3 transition-all duration-200 ease-out ${appOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1 pointer-events-none'}`}>
                            <div className="overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-900/5">
                                <div className="p-5">
                                    <p className='text-center text-base font-bold text-gray-900'>{t.appDropdown.title}</p>
                                    {/* 双平台二维码横排，面板紧凑不遮页面 */}
                                    <div className="mt-4 flex justify-center gap-6">
                                        {[
                                            { src: '../../img/download_android.png', label: 'Android' },
                                            { src: '../../img/download_apple.png', label: 'IOS' },
                                        ].map((qr) => (
                                            <div key={qr.label} className="text-center">
                                                <img src={qr.src} alt={qr.label} loading="lazy"
                                                    className="h-28 w-28 rounded-xl ring-1 ring-gray-200 bg-white p-1" />
                                                <p className='mt-1.5 text-xs text-gray-500'>{qr.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PopoverGroup>
                <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-end lg:gap-x-6">
                    <LangToggle locale={locale} />
                    <a href="../../contact2" className={navCls('/contact2')}>
                        {t.nav.contact} <span aria-hidden="true">&rarr;</span>
                    </a>
                </div>
            </nav>
            {/* <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                <div className="fixed inset-0 z-10" />
                <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center justify-between">
                        <a href="#" className="-m-1.5 p-1.5">
                            <span className="sr-only">Your Company</span>
                            <img
                                alt=""
                                src="https://tailwindui.com/plus/img/logos/mark.svg?color=indigo&shade=600"
                                className="h-8 w-auto"
                            />
                        </a>
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon aria-hidden="true" className="size-6" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6 divide-y divide-gray-500/10">
                            <div className="space-y-2 py-6">
                                <Disclosure as="div" className="-mx-3">
                                    <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50">
                                        Product
                                        <ChevronDownIcon aria-hidden="true" className="size-5 flex-none group-data-[open]:rotate-180" />
                                    </DisclosureButton>
                                    <DisclosurePanel className="mt-2 space-y-2">
                                        {[...products, ...callsToAction].map((item) => (
                                            <DisclosureButton
                                                key={item.name}
                                                as="a"
                                                href={item.href}
                                                className="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-gray-50"
                                            >
                                                {item.name}
                                            </DisclosureButton>
                                        ))}
                                    </DisclosurePanel>
                                </Disclosure>
                                <a
                                    href="#"
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Features
                                </a>
                                <a
                                    href="#"
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Marketplace
                                </a>
                                <a
                                    href="#"
                                    className="-mx-3 block rounded-lg px-3 py-2 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Company
                                </a>
                            </div>
                            <div className="py-6">
                                <a
                                    href="#"
                                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
                                >
                                    Log in
                                </a>
                            </div>
                        </div>
                    </div>
                </DialogPanel>
            </Dialog> */}


        </header>
    )
}
